import * as o from "react";
import t from "../lib/IconBase.es.js";
import n from "../defs/ArrowCircleDown.es.js";
const r = o.forwardRef((e, c) => /* @__PURE__ */ o.createElement(t, { ref: c, ...e, weights: n }));
r.displayName = "ArrowCircleDownIcon";
const m = r;
export {
  m as ArrowCircleDown,
  r as ArrowCircleDownIcon
};
